const maxPostCode = value => value?.length <= 11 ? null : 'Length cannot be more than 11 charter';

export default maxPostCode;
